module.exports = __webpack_public_path__ + "img/consultas-pre-natal.1c848826.svg";